export const NONE = "none";
export const HOURLY = "hourly";
export const DAILY = "daily";
export const WEEKLY = "weekly";
export const SUNDAY = "sunday";
export const MONDAY = "monday";
export const TUESDAY = "tuesday";
export const WEDNESDAY = "wednesday";
export const THURSDAY = "thursday";
export const FRIDAY = "friday";
export const SATURDAY = "saturday";
